/**
 * @module redux
 *
 * This module exports a custom Provider and Context and a custom set of
 * hooks to access dispatch, select, and store. This also groups
 * all redux-related logic into one place (the /behaviors folder). This
 * has the side-effect of making the hooks easier to import since they can
 * simply be included in an import of behaviours like
 * `import { actions, useDispatch, useSelector } from './behaviors`.
 */
import { createDispatchHook, createSelectorHook, createStoreHook, TypedUseSelectorHook } from 'react-redux';
import { ReduxContext } from './ReduxContext';
import { AppDispatch, RootState } from './store';

type DispatchFunc = () => AppDispatch;
const useStore = createStoreHook(ReduxContext);
const useDispatch = createDispatchHook(ReduxContext);
const useSelector = createSelectorHook(ReduxContext);

const useAppDispatch: DispatchFunc = useDispatch;
const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export { useStore, useAppDispatch, useAppSelector };
